class WishlistUtils {
  static NOT_LOGGED_WISHLIST = '/a/wishlist?type=api&version=1&wishlistid='
  static LOGGED_WISHLIST = '/a/wishlist?type=api&version=1&customerid='

  static ONLY_CUSTOMER = window.wishlist?.only_customer || false;

  static get wishlistId() {    
      const cookies = decodeURIComponent(document.cookie).split(";");
      const cookieString = "wishlist_id=";

      for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();

          if (cookie.indexOf(cookieString) === 0) {
          return cookie.substring(cookieString.length);
          }
      }

      return null;
  }

  static async retrieveWishlist() {
      if ( this.wishlist )
        return this.wishlist;

      const url = WishlistUtils.ONLY_CUSTOMER && window.customer 
        ? WishlistUtils.LOGGED_WISHLIST + window.customer.id 
        : WishlistUtils.NOT_LOGGED_WISHLIST + this.wishlistId;

      const response = await fetch(
          url,
          { cache: 'no-store' }
      );
      
      const data = await response.json();
      const items = data.items;

      localStorage.setItem('wishlist', JSON.stringify(items));

      return items;
  }
  
  static get wishlist() {
      const wishlistObj = localStorage.getItem('wishlist');
      return wishlistObj && JSON.parse(wishlistObj);
  }

  static removeFromSmartWishlist(product) {
      RemoveFromSmartWishlist(product.id, product.variant_id);
      let wishlist = this.wishlist;
      if (!wishlist )
          return;

      wishlist = wishlist.filter(item => item.id !== product.id || item.variant_id !== product.variant_id);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  static addToSmartWishlist(product) {
      AddToSmartWishlist(product.id, product.variant_id);
      let wishlist = WishlistUtils.wishlist;
      if (!wishlist )
        return;

      wishlist.push(product);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  static isInWishlist(product) {
      let wishlist = WishlistUtils.wishlist;
      if (!wishlist)
          return false;
      
      return wishlist.find(item => item.id === product.id && item.variant_id === product.variant_id);
  }

}


class CustomWishlist extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadWishlist();
    this.onWishlistChange = subscribe(
        PUB_SUB_EVENTS.wishlistChange,
        () => {this.loadWishlist();}
    );
  }

  disconnectedCallback() {
    this.onWishlistChange && this.onWishlistChange();
  }

  loadWishlist() {
      const items = WishlistUtils.wishlist;

      if (items.length) {
          this.renderItems(items);
      } else {
          this.renderEmptyState();
      }
  }

  renderEmptyState() {
      const lang = (document.documentElement.lang || 'en').slice(0, 2);
      const messages = {
        en: 'Your wishlist is empty.',
        it: 'La tua wishlist è vuota.',
        de: 'Deine Wunschliste ist leer.',
        fr: 'Votre liste de souhaits est vide.',
        es: 'Tu lista de deseos está vacía.'
      };
      const msg = messages[lang] || messages.en;
      this.querySelector('[data-grid]').innerHTML = '<p class="tw-text-center tw-py-10 tw-text-base tw-text-gray-500">' + msg + '</p>';
  }

  async renderItems(items) {
    const rootUrl = window.routes?.root_url || "";
    let fetchPromises = [];
    
    while (items.length) {  
      let handles = [];
      for (let item of items.splice(0, 10)) 
        handles.push(item.handle);

      const request = "&q=" + handles.join(",");
      const batchPromise = fetch(`${location.origin + rootUrl}/search?view=wishlist-grid${request}`).then(response => response.text());  
      fetchPromises.push(batchPromise);
    }

    const responses = await Promise.all(fetchPromises);
    let result = "";
    for (let responseText of responses) {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      result += html.querySelector('ul').innerHTML;
    } 

    this.querySelector('[data-grid]').innerHTML = result;
    
  }
}
customElements.define("custom-wishlist", CustomWishlist);

class WishlistButton extends HTMLElement {
  constructor() {
    super();

    this.product = this.getAttribute('data-product-id');
    this.variant = this.getAttribute('data-variant-id');
    this.handle = this.getAttribute('data-handle');
  }

  get item() {
    return {
        id: this.product, 
        variant_id: this.variant, 
        handle: this.handle
    }
  }

  connectedCallback() {
    this.setStyle();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      WishlistUtils.isInWishlist(this.item) ?  WishlistUtils.removeFromSmartWishlist(this.item) :   WishlistUtils.addToSmartWishlist(this.item)

      this.setStyle();
      publish(PUB_SUB_EVENTS.wishlistChange);
    });
  }

  setStyle() {
    const isInWishlist = WishlistUtils.isInWishlist(this.item);
    this.toggleAttribute('active', isInWishlist !== undefined);
  }
}
customElements.define("wishlist-button", WishlistButton);

class WishlistIcon extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadIcon();
    this.onWishlistChange = subscribe(
        PUB_SUB_EVENTS.wishlistChange,
        () => { this.loadIcon() }
    );
  }

  disconnectedCallback() {
    this.onWishlistChange && this.onWishlistChange()
  }

  async loadIcon() {
    const wishlist = await WishlistUtils.retrieveWishlist();
    const size = wishlist.length || 0;

    this.querySelector('[data-bubble]').classList.toggle('!tw-hidden', size === 0);
    this.querySelector('[data-count]').innerHTML = size;
  }

}
customElements.define("wishlist-icon", WishlistIcon);


class AccountWishlist extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadWishlist();
    this.onWishlistChange = subscribe(
        PUB_SUB_EVENTS.wishlistChange,
        () => {this.loadWishlist();}
    );
  }

  disconnectedCallback() {
    this.onWishlistChange && this.onWishlistChange();
  }

  loadWishlist() {
    const items = WishlistUtils.wishlist;
    if (items.length) this.renderItems(items);
  }

  async renderItems(items) {
    const rootUrl = window.routes.root_url || "";
    let fetchPromises = [];
    
    while (items.length) {  
      let handles = [];
      for (let item of items.splice(0, 10)) 
        handles.push(item.handle + "@" + item.variant_id);

      const request = "&q=" + handles.join(",");
      const batchPromise = fetch(`${location.origin + rootUrl}/search?view=wishlist-table${request}`).then(response => response.text());  
      fetchPromises.push(batchPromise);
    }

    const responses = await Promise.all(fetchPromises);
    let result = "";
    for (let responseText of responses) {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      result += html.querySelector('[data-table]').innerHTML;
    } 

    this.querySelector('[data-table]').innerHTML = result;
    
  }
}
customElements.define("account-wishlist", AccountWishlist);

class WishlistRowItem extends HTMLTableRowElement {
  constructor() {
    super();
    
    this.product = this.getAttribute('data-product-id');
    this.variant = this.getAttribute('data-variant-id');
    this.handle = this.getAttribute('data-handle');
  }

  get item() {
    return {
        id: this.product, 
        variant_id: this.variant, 
        handle: this.handle
    }
  }

  connectedCallback() {
    this.setListeners();
  }

  setListeners() {
    this.querySelectorAll('[data-remove]').forEach((button) => {
      button.addEventListener('click', (event) => {
        WishlistUtils.removeFromSmartWishlist(this.item);
        publish(PUB_SUB_EVENTS.wishlistChange);
      });
    });

    this.querySelector('form').addEventListener('submit', (event) => {
      this.onsubmit(event);
    });

    this.addEventListener('theme:product:add', (event) => {
      this.onCartUpdate(event);
    });
  }

  onCartUpdate(event) {
    const productId = event.detail.response.product_id;
    const variantId = event.detail.response.variant_id;

    if (this.product == productId && this.variant == variantId) {
      WishlistUtils.removeFromSmartWishlist(this.item);
      publish(PUB_SUB_EVENTS.wishlistChange);
    }
  }

  async onsubmit(event) {
    event.preventDefault();

    document.dispatchEvent(
      new CustomEvent("theme:cart:add", {
        detail: {
          button: this.querySelector('button[type="submit"]'),
        },
        bubbles: true,
      })
    );
        
    publish(PUB_SUB_EVENTS.wishlistChange);  
  }

}

customElements.define("wishlist-row-item", WishlistRowItem, { extends: "tr" });